import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  // The light theme below is the DEFAULT (used by the user-facing forms).
  // Admin forms pass overrides like `bg-gray-800 text-white`. Tailwind resolves
  // conflicting utilities by stylesheet order — NOT class-attribute order — so a
  // hardcoded default `text-gray-900` could beat a consumer's `text-white`,
  // producing dark text on a dark field. To make overrides reliably win, we drop
  // each default whenever the consumer supplies an override for that property.
  const hasBg = /(^|\s)bg-/.test(className);
  const hasText = /(^|\s)text-(?!sm|base|lg|xl|center|left|right)/.test(className);
  const hasBorderColor = /(^|\s)border-(?!2|0|\[)/.test(className);
  const defaultBg = hasBg ? '' : 'bg-white/90 backdrop-blur-sm';
  const defaultText = hasText ? '' : 'text-gray-900';
  const defaultBorderColor = hasBorderColor ? '' : error ? 'border-red-400 focus:ring-red-200' : 'border-transparent';
  return <div className="w-full" data-id="element-783" data-mp="2c3cjjlviarkc">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-white mb-1.5 ml-1 drop-shadow-sm" data-id="element-784" data-mp="2c21frm229jt8">
          {label}
        </label>}
      <input id={inputId} className={`
          w-full px-5 py-4 rounded-2xl border-2 placeholder:text-gray-400 font-medium
          focus:outline-none focus:ring-4 focus:ring-brand-purple/15 focus:border-brand-purple
          transition-all duration-200
          ${defaultBg} ${defaultText} ${defaultBorderColor}
          ${className}
        `} {...props} data-id="element-785" data-mp="233zgpc1w118l" />
      {error && <p className="mt-1.5 text-sm text-red-100 font-medium ml-1 bg-red-500/20 px-2 py-0.5 rounded inline-block" data-id="element-786" data-mp="1kbx0g1t5rmyv">
          {error}
        </p>}
    </div>;
}